export default {
  accounts: [],
  loadingAccounts: false,
  page: {},
  links: {},
  accountsSearchValue: null,
  filters: [],
  filtersConfiguration: [],
  rolePermissions: {
    loading: false,
    statusesPermissions: [],
    accountEventRestrictions: [],
    supportFileRestrictions: []
  },
  selectedDates: {
    dateFrom: null,
    dateTo: null
  },
  accountDetail: {
    selectedAccount: {},
    accountCharges: {
      loading: false,
      page: {},
      links: {},
      filters: [],
      charges: []
    },
    supportFiles: {
      loading: false,
      byCharge: {
        pending: {
          page: {},
          files: []
        },
        received: {
          page: {},
          files: []
        },
        general: {
          page: {},
          files: []
        }
      },
      byAccount: {
        pending: {
          page: {},
          files: []
        },
        received: {
          page: {},
          files: []
        },
        general: {
          page: {},
          files: []
        }
      },
      all: {
        pending: {
          page: {},
          files: []
        },
        received: {
          page: {},
          files: []
        },
        general: {
          page: {},
          files: []
        }
      }
    },
    reassignedAccounts : {
      loadingAccounts: false,
      page: {},
      links: {},
      accounts: []
    },
    isConcurrentAccount: false,
    isInvoicedAccount: false,
    isReadyToAudit: false,
    isMultiPatientAccount: false,
    isMultiEventSamePatientAccount: false,
  },
  chargeDetail: {
    selectedCharge: {}
  },
  auditComments:{},
  agreements: {
    content: [],
    links: {},
    page: {},
    loading: false
  },
  selectedAgreement: {},
  agreementConfiguration: {},
  selectedAuditRule: {},
  healthcarePlans: [],
  serviceSupportDocuments: {
    loading: false,
    byAccount: {
      page: {},
      files: []
    },
    byCharge: {
      page: {},
      files: []
    },
  },
  supportFileTypes: [],
  payers: [],
  agreementProducts: {
    loading: false,
    page: {},
    content: []
  },
  supportDocuments: {
    loading: false,
    documents: []
  },
  displayCommentDialog: false,
  commentControl: {},
  roleRcmUser: null,
  providerServiceTypes: [],
  providerExecutorServices: [],
  providerAgreementPlanTypes: [],
  providerInvoiceSources: [],
	providerAgreements: [],
  providerSupportDocuments: [],
  accountListSort: null,
  agreementsFilters: [],
  preSettlements: {
    content: [],
    links: {},
    page: {
      size: 15,
      number: 0,
    },
    filters: []
  },
  preSettlementDetail: {
    files: [],
    invoices: [],
  },
  preSettlementFolderConfiguration: {},
  uploadedAgreementMatrix: {
    content: [],
    page: {},
    links: {},
    loading: false
  },
  uploadAgreementMatrixResult: {
    status: false,
    errors: [],
    result: null,
    loading: false
  },
  supportFormatFileFields: [],
  selectedPackageGroup: null,
  openPackageGroupDialog: false,
  selectedPackageAction: null,
  providerProducts: [],
  providerProductsSearchValue: null,
  providerProductsLoading: false,
  providerProductConfigurationDialog: false,
  selectedProviderProduct: null,
  providerProductConfigurationIndex: null,
  accountDefaultFiltersValuesApplied: false,
  users: []
}
